import { getAuth } from "firebase/auth";
import { fireBaseApp } from './firebaseApp';

export const auth = getAuth(fireBaseApp);
